import { Layout } from '@sunwebgroup/uds-ui/layout'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useCMSPageField } from '@/cms/fields'
import { BRAND } from '@/constants'
import { Footer } from '@/scopes/common/components'
import { CatalogueContent } from '@/scopes/common/components/Footer/CatalogueContent'
import { Header } from '@/scopes/common/components/Header'
import {
  createAccoListerApiClient,
} from '@/scopes/common/infrastructure/acco-lister/accoListerApiClient'
import { destinationMapAPIClient } from '@/scopes/common/infrastructure/api/destination-map'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import Breadcrumbs from '@/scopes/destinations/components/Breadcrumbs/Breadcrumbs'
import Hero from '@/scopes/destinations/components/Destination/Hero'
import { destinationActions } from '@/scopes/destinations/domain/actions'
import { destinationStore } from '@/scopes/destinations/infrastructure/store/destination-store'
import ElizaContent from '@/scopes/destinations/pages/ElizaContent'
import SunwebContent from '@/scopes/destinations/pages/SunwebContent'
import NotFoundBanner from '../components/NotFoundBanner'
import { createDestinationClient } from '../infrastructure/api/destinationDataClient'
import { DestinationDependenciesProvider, useDestinationActions } from '../infrastructure/depedencies/dependencies'
import styles from './Destination.module.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
    },
  },
})

function Destination() {
  const actions = useDestinationActions()

  useEffect(() => {
    const load = async () => {
      await actions.pageLoaded()
    }
    load()
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <div>
        <Header />
        <Layout as="main" id="main-content" tabIndex={-1}>
          <NotFoundBanner />
          <Hero />
          <div className={styles.content}>
            <Breadcrumbs />
            <PerBrandContent />
          </div>
        </Layout>
        <Footer>
          <CatalogueContent />
        </Footer>
      </div>
    </QueryClientProvider>
  )
}

function PerBrandContent() {
  const brandName = useConfiguration('brandName')

  if (brandName === BRAND.ELIZA) {
    return (<ElizaContent />)
  }

  return <SunwebContent />
}

export default function Page() {
  const contextItemId = useCMSPageField('contextItemId')
  const datasourceId = useCMSPageField('DestinationPage.datasourceId')
  const template = useCMSPageField('template')
  const deskId = useCMSPageField('DestinationPage.deskId')
  const googleMapsApiKey = useConfiguration('thirdParties.googleMapsApiKey')

  const actions = destinationActions({
    store: destinationStore,
    destinationMapApiClient: destinationMapAPIClient,
    destinationsSelectorClient: createDestinationClient({ contextItemId, datasourceId }),
    accoListerApiClient: createAccoListerApiClient({ contextItemId, datasourceId, template, deskId }),
  })

  if (!contextItemId || !datasourceId) {
    return null // 404 500
  }

  return (
    <>
      <DestinationDependenciesProvider dependencies={{ googleMapsApiKey, actions }}>
        <Destination />
      </DestinationDependenciesProvider>
    </>
  )
}
